<template>
    <ul class="nrk work">
        <li v-for="item in Cate.data" :key="item.id" @click="List(item.id,item.title)">
            <div class="img-nrk">
            <img v-lazy="Http+item.image">
            </div>
            <span>
                {{item.title}}
            </span>
        </li>
    </ul>
</template>

<script>
import{mapState} from'vuex';
export default {
    mounted() {

    },
    computed:{
        ...mapState({
            Cate:state=>state.share.Cate,
            Http:state=>state.share.Http
        })
    },
    methods: {
        List(id,title){
            this.$router.push({
                name:'List',
                    query:{
                        id:id,
                        title:title,
                    }
            })
        }
    },
}
</script>

<style scoped>
    .work{
        overflow: hidden;
        margin: 20px auto;
        padding: 2% 2%;
    }
    .work li{
        width: 32%;
        float: left;
        margin-right: 2%;
        cursor: pointer;
        box-shadow: 0px 3px 3px #d9d9d9;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        overflow: hidden;
        max-height: 400px;
        margin-bottom: 40px;
    }
    .work li:nth-child(3n){
        margin-right: 0;
    }
    .work li .img-nrk{
        width: 100%;
        height: 300px;
        overflow: hidden; 
    }
    .work li .img-nrk img{
        width: 100%;
        margin: 0 auto;
        border-radius: 10px;
        height: 300px;    
    }
    .work li:hover img {
    transform: scale(1.1);
    transition: all 0.5s ease; 
    }
    .work li span{
        text-align: center;
        display: block;
        margin: 34px 0;
        font-size: 18px;
    }
    .work li:hover{
        color: #0019a7;
    }
    @media (max-width: 768px){
        .work li{
            width: 100%;
        }
        .work li .nmkimg,.work li img{
            height: auto;
        }
    }
</style>